'use client';

import GlowingBorder from '@/app/(football)/[team]/_components/common/GlowingBorder';
import {
  MiniGameRankingListEmpty,
  MiniGameRankingListItem,
  MiniGameRankingListItemSkeleton,
} from '@/app/(football)/[team]/_components/common/MiniGameRankingListItem';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useGetBlockMiniGameRankingWithInitQuery } from '@/store/server/common/football/football.query';

export default function RankingList() {
  const { originalsName, teamSlug } = useTeamConfig();

  const { data: rankingData, isLoading } = useGetBlockMiniGameRankingWithInitQuery({
    originalsName,
  });

  return (
    <div className="pt-6">
      <div className="flex justify-between p-3">
        <div>
          <span className="typo-body-4 text-g-00">순위</span>
          <span className="pl-5 typo-body-4 text-g-00">닉네임</span>
        </div>
        <span className="typo-body-4 text-g-00">블록층수</span>
      </div>
      <ul className="flex flex-col gap-3">
        {(() => {
          if (isLoading) {
            return new Array(5).fill(0).map((_, index) => <MiniGameRankingListItemSkeleton key={index} />);
          }

          if (rankingData?.top?.length === 0 || !rankingData?.top) {
            return (
              <MiniGameRankingListEmpty
                imageSrc={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_game.webp`}
                imageAlt="미니게임 랭킹 데이터 없음 아이콘"
              >
                지금 미니게임에 도전하고
                <br />
                포인트 받아가세요!
              </MiniGameRankingListEmpty>
            );
          }

          return (
            <>
              {rankingData?.my && (
                <MiniGameRankingListItem
                  key={rankingData.my.ranking}
                  isMine
                  ranking={rankingData.my.ranking}
                  nickName={rankingData.my.nickName}
                  profileImage={rankingData.my.profileImg}
                  value={rankingData.my.amount}
                />
              )}
              {rankingData?.top?.map((item) => {
                const isFirstPlace = item.ranking === 1;

                return (
                  <div key={`${item.nickName}_${item.ranking}`} className="relative">
                    {isFirstPlace && <GlowingBorder backgroundColor="var(--color-mini-game-ranking-list-first-bg)" />}
                    <MiniGameRankingListItem
                      ranking={item.ranking}
                      nickName={item.nickName}
                      profileImage={item.profileImg}
                      value={item.amount}
                      isFirstPlace={isFirstPlace}
                    />
                  </div>
                );
              })}
            </>
          );
        })()}
      </ul>
    </div>
  );
}
